import { DataEnum } from "models";

export const UNDEFINED_LOCK_OPTION = {
  show: false,
  min: { value: undefined, type: DataEnum.None },
  max: { value: undefined, type: DataEnum.None }
};
